export const PHYSICAL_APPLICANT_FIELDS = ['pnum', 'ssn', 'policy'];
export const LEGAL_APPLICANT_FIELDS = ['hvhh', 'policy'];

export const PHYSICAL_PERSONAL_INFORMATION_FIELDS = [
  'applicantIs',
  'formLanguage',
  'passportGiven',
  'passportValidUntil',
  'passportFrom',
  'selectedProperties',
  'isCitizen',
];

export const LEGAL_PERSONAL_INFORMATION_FIELDS = [
  'applicantIs',
  'formLanguage',
  'applicantCitizenship',
  'applicantGender',
  'applicantBDay',
  'selectedProperties',
];

export const ACCIDENT_INFO_FIELDS = [
  'accidentDate',
  'accidentTime',
  'accCountry',
  'accState',
  'accVillage',
  'loanAgreementExists',
  'startDate',
  'endDate',
  'accidentDiscovererIs',
  'damageAmount',
  'damageCauses',
  'organizations',
  'accidentDetails',
  'accidentPrevention',
  'formLanguage',
];

export const APPLICANT_IS = {
  owner: { value: 'owner', label: 'propertyClaim.personalData.owner' },
  other: { value: 'other', label: 'propertyClaim.personalData.other' },
  otherLegal: { value: 'otherLegal', label: 'propertyClaim.personalData.other' },
};

export const PROPERTY_OWNER_IS = {
  insuredPerson: { value: 'insuredPerson', label: 'propertyClaim.personalData.insuredPerson' },
  applicant: { value: 'applicant', label: 'propertyClaim.personalData.applicant' },
  other: { value: 'other', label: 'propertyClaim.personalData.other' },
};

export const ACCIDENT_DISCOVERER_IS = {
  owner: { value: 'owner', label: 'propertyClaim.accInfo.owner' },
  reporter: { value: 'reporter', label: 'propertyClaim.accInfo.reporter' },
  other: { value: 'other', label: 'propertyClaim.accInfo.other' },
};

export const PAYMENT_RECEIVER_TYPES = [
  { value: 'owner', label: 'propertyClaim.compensation.paymentReceiverType.owner' },
  {
    value: 'applicant',
    label: 'propertyClaim.compensation.paymentReceiverType.applicant',
  },
  { value: 'other', label: 'propertyClaim.compensation.paymentReceiverType.other' },
];

export const DEFAULT_DAMAGED_PROPERTIES = [{ id: 1 }];
